export default {
  url: process.env.REACT_APP_SENTRY_URL,
  env: process.env.REACT_APP_SENTRY_ENV,
}
